import { Container } from '@/components/common/container';
import { SearchResultsListContent } from '.';

export function SearchResultsListPage() {
  return (
    <Container>
      <SearchResultsListContent />
    </Container>
  );
}
